module.exports = __webpack_public_path__ + "img/trastorno-ninos.4b53503a.jpg";